// extracted by mini-css-extract-plugin
export default {"subTitle":"HmqFt0lp3isGal6y0eZHpQ==","link":"_6CodnBTmlCsOF277rH4mHA=="};